import { createConnectTransport } from '@connectrpc/connect-web';
import type { GpRegion } from './grpc/universal/types';
import { getSecondaryRegion } from './grpc/universal/utils';

export default defineNuxtPlugin(() => {
  const { public: publicConfig } = useRuntimeConfig();
  const { grpc } = publicConfig;
  const primaryRegion = grpc.primaryRegion as GpRegion;
  const secondaryRegion = getSecondaryRegion(grpc.primaryRegion as GpRegion);

  const primaryTransport = createConnectTransport({
    baseUrl: grpc.endpoints[primaryRegion],
    credentials: 'include',
  });

  const secondaryTransport = createConnectTransport({
    baseUrl: grpc.endpoints[secondaryRegion],
    credentials: 'include',
  });

  return {
    provide: {
      primaryTransport,
      secondaryTransport,
    },
  };
});
